<app-cerrix-tree-item-picker
    [name]="name"
    [label]="label"
    [infoText]="infoText"
    [placeholder]="placeholder"
    [dialogTitle]="dialogTitle"
    [iconPrefix]="iconPrefix"
    [defaultIcon]="defaultIcon"
    [items]="items"
    [multiselect]="true"
    [selectedValue]="selectedValue"
    (valueChanged)="valueChanged.emit($event)"
></app-cerrix-tree-item-picker>
